

export class EventBriteFetcher {
    private ebToken: string | null = null

    fetch(input: RequestInfo, init?: RequestInit): Promise<Response> {

        const callOut = (ebToken: string) => {
            const headers = new Headers({
                'Authorization': 'Bearer ' + ebToken
            })
            if(init != null){
                let objHeaders = init!.headers;
                if(objHeaders){
                    Object.keys(objHeaders as any).forEach((key:string) => {
                        headers.append(key, (objHeaders as any)[key] as string)
                    })
                }
            }
            return fetch(input, {
                ...init,
                headers: headers
            })
        }
        if (!this.ebToken) {
            return fetch(`${process.env.REACT_APP_API_CALL}/user-eventbrite-token`, {
                credentials: 'include'
            })
                .then(response => response.json())
                .then(response => {
                        this.ebToken = response.eventbrite_token
                        return callOut(this.ebToken!)
                    }
                ) as Promise<Response>
        } else {
             return callOut(this.ebToken!)
        }
    }
}
